exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-dashboard-widgets-textual-style-___styles__customColor___E5FOl {\n  display: flex;\n  padding-left: 5px;\n  margin-top: 3px;\n}\n\n.src-components-dashboard-widgets-textual-style-___styles__customColor___E5FOl input {\n  margin-bottom: 0;\n  font-size: 13px;\n  width: 52px;\n  height: 19px;\n  margin-left: 3px;\n}", ""]);

// exports
exports.locals = {
	"customColor": "src-components-dashboard-widgets-textual-style-___styles__customColor___E5FOl"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/dashboard/widgets/textual/style/styles.scss
// module id = 1925
// module chunks = 0